const articleTemplate = require('./zendesk-article-template.html');
const atmArticleVoteMapper = require('./article-vote-mapper');

module.exports = function ArticleDirective(helpCenterService, $sce, atm) {
    return {
        restrict: 'E',
        scope: {
            article: '='
        },
        template: articleTemplate,
        link: function (scope) {
            scope.relatedArticles = [];
            scope.categories = [];
            scope.categorySectionsMap = [];
            scope.currentCategoryName = "";
            scope.currentSectionName = "";
            scope.sections = [];
            scope.topic = "";
            scope.$watch('article', function (article) {
                scope.article = article;
                scope.categorySectionsMap = JSON.parse(sessionStorage.getItem("category-section-map"));
                if (scope.categorySectionsMap == null || scope.categorySectionsMap.length === 0) {
                    scope.categorySectionsMap = [];
                    helpCenterService.getCategories()
                        .then(function (categories) {
                            scope.categories = categories;
                            scope.$evalAsync();

                            var categoryPromises = [];

                            scope.categories.forEach(function (category) {
                                categoryPromises.push(
                                    helpCenterService.getSectionsByCategoryId(category.id)
                                        .then(function (sections) {
                                            // Once sections are fetched, add them to the map
                                            var sectionData = sections.map(function (section) {
                                                return {
                                                    sectionId: section.id,
                                                    sectionName: section.name,
                                                    categoryName: category.name
                                                };
                                            });

                                            scope.categorySectionsMap.push({
                                                categoryId: category.id,
                                                sectionData: sectionData
                                            });
                                            scope.$evalAsync();
                                        })
                                        .catch(function (error) {
                                            console.error("Error fetching sections:", error);
                                        })
                                );
                            });

                            Promise.all(categoryPromises)
                                .then(function () {
                                    setCurrentCategorySection(article.section_id);
                                    sessionStorage.setItem("category-section-map", JSON.stringify(scope.categorySectionsMap));
                                })
                                .catch(function (error) {
                                    console.error("Error processing sections:", error);
                                });
                        });
                }
                else {
                    setCurrentCategorySection(article.section_id);
                }
                if (scope.relatedArticles.length === 0) {
                    helpCenterService.getArticlesBySectionId(scope.article.section_id)
                        .then(function (articles) {
                            scope.relatedArticles = articles;
                            scope.$evalAsync();
                        })
                        .catch(function (error) {
                            console.error("Error fetching related articles:", error);
                        });
                }
            });

            scope.trustHtml = function (articleBody) {
                return $sce.trustAsHtml(articleBody);
            };
            scope.viewRelatedArticle = function (relatedArticle) {
                scope.article = relatedArticle;
            }
            scope.showHelpCenter = function () {
                scope.$parent.showLandingPageTemplate();
            };
            scope.showSection = function () {
                scope.$parent.showSectionsArticles(scope.currentCategoryId);
            };

            scope.voteArticle = function(voteType) {
              atm.push({
                 linkName: `web:article page:${scope.article.id}:helpfulness rating:${voteType}`
                                     }, atmArticleVoteMapper);
            };
            function getCategoryAndSectionNameFromSectionId(sectionId) {
                for (let categorySection of scope.categorySectionsMap) {
                    var sectionData = categorySection.sectionData;
                    for (let sectionDetails of sectionData) {
                        if (sectionDetails.sectionId === sectionId) {
                            return { categoryId: categorySection.categoryId, categoryName: sectionDetails.categoryName, sectionName: sectionDetails.sectionName }; // Return the category name
                        }
                    }
                }
                return null; // Return null if section not found
            }

            function setCurrentCategorySection(sectionId) {
                var categorySectionInfo = getCategoryAndSectionNameFromSectionId(sectionId);
                scope.currentCategoryName = categorySectionInfo.categoryName;
                scope.currentSectionName = categorySectionInfo.sectionName;
                scope.currentCategoryId = categorySectionInfo.categoryId;
                scope.$evalAsync();
            }

        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/help-center/zendesk-article-directive.js
 **/